import React, { useState, useEffect } from "react";
import AnimatedPageContainer from "../../../assets/containers/AnimatedPageContainer";
import VideoBanner from "../../../assets/components/VideoBanner";
import CustomButton from "../../../assets/components/CustomButton";
import errorHandler from "../../../assets/utils/ErrorHandler";
import { getMyPrice, purchase } from "../../../assets/services/apiServices";
import Loading from "../../../assets/containers/loadingDialog";

const PeleBaroon = () => {
  const [price, setPrice] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getPrice();
  }, []);

  const getPrice = async () => {
    setIsLoading(true);
    try {
      const response = await getMyPrice();
      setPrice(response.data.ticketPrice);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      errorHandler(err);
    }
  };

  const purchasePele = async () => {
    setIsLoading(true);
    try {
      setIsLoading(false);
      const response = await purchase();
      window.open(response.data.link, "_blank", "noopener,noreferrer");
    } catch (err) {
      setIsLoading(false);
      errorHandler(err);
    }
  };

  return (
    <AnimatedPageContainer>
      <div className="customContainer">
        <div className="d-flex justify-content-center mb-4">
          <img src="/images/pelebaroon/logo.png" className="w-50" alt="logo" />
        </div>
        <VideoBanner
          bannerData={{
            videoCover: "/images/pelebaroon/videoBg.png",
            src: "https://api.v2.rahebehesht.com/file/get/%D9%BE%D9%84%D9%87%20%D8%A8%D8%A7%D8%B1%D9%88%D9%86_1740383170.mp4",
          }}
        />
        <div className="my-4">
          <img
            src="/images/pelebaroon/banner.png"
            alt="banner"
            className="img-fluid"
          />
        </div>
        {isLoading ? (
          <div className="d-flex justify-content-center my-5">
            <Loading />
          </div>
        ) : (
          <>
            <div className="mb-2">
              <p>قیمت بلیط چالش برای شما: {price===0 ? "در حال محاسبه" : `${price} کلید`} </p>
            </div>
            <div className="mb-4">
              زمان برگزاری چالش: ۹ اسفند ساعت ۱۹
            </div>
              {
                price !== 0 &&
                <CustomButton
                  clickHandler={purchasePele}
                  color={"primary"}
                  shadow
                  text={ isLoading ? "در حال خرید بلیط..." : "شروع چالش"}
                />
              }
          </>
        )}

        <div className="my-5"></div>
      </div>
    </AnimatedPageContainer>
  );
};

export default PeleBaroon;
